<app-final-lens [isNotReturn]="false" [returnItem]="data.returnItem" #finalLens></app-final-lens>
<button mat-flat-button color="primary" class="center" (click)="save()">{{"newOrder.finalLens.updateItem" | translate}}</button>
